import { Fragment, useState } from "react";
import { Plus } from "react-feather";
import { Form, FormGroup, Input } from "reactstrap";
import { Href } from "../../../../Constants/Constants";
import NotesModal from "./NotesModal";

const NotesForm = () => {
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);
  return (
    <Fragment>
      <Form className="default-form">
        <FormGroup className="notes-content">
          <Input type="select">
            <option>Contact Or Channel</option>
            <option>Weekdays (Mon-Fri)</option>
            <option>Daily</option>
            <option>Weekly (Custom)</option>
          </Input>
          <ul>
            <li>
              <a className="icon-btn btn-light button-effect btn-sm" href={Href} onClick={toggle}><Plus /></a>
            </li>
          </ul>
        </FormGroup>
      </Form>
      <NotesModal modal={modal} toggle={toggle} />
    </Fragment>
  );
};

export default NotesForm;
